import { Dispatch } from "react";

import api from "../api";
import { AdvertiserType } from "../types/advertiserTypes";
import { CAMPAIGN_PLAY_TYPE } from "../constants/campaignPlayTypes";
import { CURRENT_BRANDGEN_ADVERTISER_ID_STORAGE_KEY } from "../constants/storageKeys";
import { mapAdGroupTemplateToAdGroupToCreate } from "../types/campaignTypes";
import {
  setAdGroupToCreate,
  setCampaignBasicDetails,
  setCampaignCookies,
  setCampaignLandingPage,
  setCampaignPlayType,
  setCampaignSteps,
  setCampaignTemplate,
  setCampaignTemplateName,
  setCampaignToCreateSelectedAdvertiser,
  setFoundCompanyInfo,
  setFoundEmailsInfo,
  setSelectedAdGroupTemplate,
  setSelectedDomainIds,
  setSelectedDomainListsIds,
  setSelectedDomainNames,
  setSelectedGeoTargetOptions,
  setSelectedSegmentIds,
  setSelectedZipCodes,
} from "../redux/reducers/campaignToCreate";
import { toCampaignDateISO } from "./campaignDateUtils";

const toArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map((id: string | number) => String(id));
  }
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return Object.values(value).map((id) => String(id));
  }
  return [];
};

export const initializeStateWithTemplateData = async (
  template: any,
  dispatch: Dispatch<any>,
  advertisers: AdvertiserType[],
) => {
  dispatch(setCampaignSteps(template.templateSteps));
  if (template.campaignType) {
    dispatch(setCampaignPlayType(template.campaignType as CAMPAIGN_PLAY_TYPE));
  }
  dispatch(
    setCampaignBasicDetails({
      agencyId: template.agencyId,
      createdBy: template.createdBy,
      name: template.name,
      description: template.description,
      startDate: template.startDate ? toCampaignDateISO(template.startDate) : template.startDate,
      endDate: template.endDate ? toCampaignDateISO(template.endDate) : template.endDate,
      estimatedBudget: template.estimatedBudget,
      dailyBudget: template.dailyBudget,
      maxBid: template.maxBid,
      showInHubspot: template.showInHubspot,
      maxCompanies: template.maxCompanies,
      isVideoCampaign: template.isVideoCampaign,
    }),
  );
  const globalAdvertiserId =
    localStorage.getItem(CURRENT_BRANDGEN_ADVERTISER_ID_STORAGE_KEY) ?? template.selectedAdvertiser;
  const selectedAdvertiser =
    advertisers.find((advertiser) => advertiser.brandgenAdvertiserId === globalAdvertiserId) ?? advertisers[0];

  if (selectedAdvertiser) {
    dispatch(setCampaignToCreateSelectedAdvertiser(selectedAdvertiser));
  }
  dispatch(setFoundCompanyInfo(template.foundCompanyInfo));
  dispatch(setFoundEmailsInfo(template.foundEmailsInfo));
  dispatch(setSelectedGeoTargetOptions(template.selectedGeoTargetOptions ?? []));
  dispatch(setCampaignCookies(template.campaignCookieSets));
  dispatch(setCampaignLandingPage(template.landingPage));
  dispatch(setAdGroupToCreate(template.adGroupToCreate));
  dispatch(setSelectedAdGroupTemplate(template.selectedAdGroupTemplate));
  dispatch(setSelectedZipCodes(template.selectedZipCodes));
  dispatch(setSelectedSegmentIds(template.selectedSegmentIds));
  dispatch(setSelectedDomainListsIds(toArray(template.selectedDomainListsIds)));
  dispatch(setSelectedDomainIds(toArray(template.selectedDomainIds)));
  dispatch(setSelectedDomainNames(toArray(template.selectedDomainNames)));
  dispatch(setCampaignTemplateName(template.templateName));
  dispatch(setCampaignTemplate(template));

  if (template.selectedAdGroupTemplate) {
    try {
      const adGroupTemplate = await api.getAdGroupById(template.selectedAdGroupTemplate);
      const adGroupToCreate = mapAdGroupTemplateToAdGroupToCreate(adGroupTemplate);
      dispatch(setAdGroupToCreate(adGroupToCreate));
    } catch (error) {
      console.error("Failed to fetch ad group from selected template:", error);
    }
  }

  if (template.id) {
    try {
      const roleTitles = await api.getRoleTitlesForTemplate(template.id);
      dispatch(setCampaignCookies(roleTitles));
    } catch (error) {
      console.error("Failed to fetch ad group from selected template:", error);
    }
  }
};
